jQuery(function ($) {
  $(".js-modal-btn").modalVideo();
});
